import axios from 'axios';
import get from 'lodash/get';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import qs from 'query-string';
import qsFilters from 'qs';

// Libs
import { thunkHandler, thunkErrorHanlder, parseUrl, Consequence, getTrueProperties } from '../../libs/utils';

// Constants
import {
  INVOICE_BASE,
  INVOICE_SINGLE,
  INVOICE_SINGLE_COLLECTION,
  INVOICE_ITEMS,
  INVOICE_COLLECTION,
  INVOICE_FILES,
  INVOICE_NOTE,
  INVOICE_EXPORT,
  INVOICE_SINGLE_COLLECTION_SMS,
  INVOICE_EMIT_CFDI,
  INVOICE_CFDI,
  INVOICE_INVOICE,
  INVOICE_IMPORT_XML,
  INVOICE_CANCEL_CFDI,
  INVOICE_CANCEL_NOTIFY,
  CREDIT_NOTE_BASE,
  CREDIT_NOTE_SINGLE,
  CREDIT_NOTE_CANCEL_CFDI,
  CREDIT_NOTE_CANCE_NOTIFY,
  INVOICE_CREDIT_NOTE,
  CLIENT_INVOICES_FROM_UUID,
  CLIENT_INVOICES,
  INVOICE_NOTE_IMPORT,
  CLIENT_GENERATE_CFDI,
  CREDIT_NOTE_EXPORT,
  INVOICE_SINGLE_COLLECTION_WHATSAPP
} from '../../constants/endpoints';

// JSON
import invoiceExample from '../resources/invoice_example.json';
import reminderExample from '../resources/reminder_example.json';

import { getPackagesStats } from '../actions/permsActions';

export const SEND_COLLECTION_NOTICE = 'SEND_COLLECTION_NOTICE';
export const NEW_SINGLE_INVOICE = 'NEW_SINGLE_INVOICE';
export const NEW_INVOICE_COLLECTION = 'NEW_INVOICE_COLLECTION';
export const NEW_INVOICE_ITEMS = 'NEW_INVOICE_ITEMS';
export const NEW_INVOICES = 'NEW_INVOICES';
export const NEW_STATS = 'NEW_STATS';
export const INVOICES_TO_PAY = 'INVOICES_TO_PAY';
export const NEW_INVOICE_NOTE = 'NEW_INVOICE_NOTE';
export const NEW_EXPORT_INVOICES = 'NEW_EXPORT_INVOICES';
export const NEW_IMPORT_INVOICES = 'NEW_IMPORT_INVOICES';
export const NEW_IMPORT_NOTES = 'NEW_IMPORT_NOTES';
export const NEW_SINGLE_CREDIT_NOTE = 'NEW_SINGLE_CREDIT_NOTE';
export const NEW_FILTERS = 'NEW_FILTERS';
export const NEW_VALUES = 'NEW_VALUES';
export const NEW_LOADING_TABLE = 'NEW_LOADING_TABLE';
export const NEW_SEARCHING = 'NEW_SEARCHING';
export const RELOAD_INVOIDE_TABLE = 'RELOAD_INVOIDE_TABLE';
export const CHANGE_INVOICE_SELECT = 'CHANGE_INVOICE_SELECT';

export function sendCollectionNotice(uuid, body, isUnlimited) {
  return dispatch =>
    axios.post(parseUrl(INVOICE_COLLECTION, { uuid }), body).then(() => {
      if (!isUnlimited) {
        dispatch(getPackagesStats());
      }
    });
}

export function sendCollectionNoticeSms(uuid, body, isUnlimited) {
  return dispatch =>
    axios.post(parseUrl(INVOICE_SINGLE_COLLECTION_SMS, { uuid }), body).then(() => {
      if (!isUnlimited) {
        dispatch(getPackagesStats());
      }
    });
}

export function sendCollectionNoticeWhatsApp(uuid, body, isUnlimited) {
  return dispatch =>
    axios.post(parseUrl(INVOICE_SINGLE_COLLECTION_WHATSAPP, { uuid }), body).then(() => {
      if (!isUnlimited) {
        dispatch(getPackagesStats());
      }
    });
}

export function createNewInvoiceNote(body) {
  return dispatch =>
    axios
      .post(INVOICE_NOTE, body)
      .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_SINGLE_INVOICE, 'ERROR'))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END createNewInvoiceNote

export function newInvoice(invoice) {
  return dispatch =>
    Promise.resolve(invoice)
      .then(invoice => dispatch({ type: NEW_SINGLE_INVOICE, payload: invoice }))
      .catch(error => dispatch({ type: 'ERROR', payload: error }));
} // END newInvoice

export function newInvoices(invoices) {
  return dispatch =>
    Promise.resolve(invoices)
      .then(invoices => dispatch({ type: NEW_INVOICES, payload: { page: invoices } }))
      .catch(error => dispatch({ type: 'ERROR', payload: error }));
} // END newInvoices

export function newStats(stats) {
  return dispatch =>
    Promise.resolve(invoices)
      .then(stats => dispatch({ type: NEW_STATS, payload: { filters_stats: stats } }))
      .catch(error => dispatch({ type: 'ERROR', payload: error }));
} // END newInvoices

export function getInvoices(params, source) {
  if (typeof params !== 'object' && !Array.isArray(params)) params = {};
  const qsObj = {};
  const { activeTab, page, code, customer, startDate, endDate, cancelToken, sort } = params;

  if (activeTab && source) qsObj.filter = filterCatalog(activeTab);
  if (activeTab && activeTab === '6') qsObj.filter = filterCatalog(activeTab);
  if (activeTab && !source && activeTab !== '6') qsObj.type = newfilterCatalog(activeTab);
  if (page) qsObj.page = page;
  if (code) qsObj.code = code;
  if (customer) qsObj.customer = customer;
  if (sort) qsObj.sort = sort;
  if (startDate) {
    qsObj.start = startDate;
    if (endDate) qsObj.end = endDate;
    else qsObj.end = moment().format('YYYY-MM-DD');
  } // END if
  if (typeof params.dueDate === 'number') qsObj.due = params.dueDate;

  if (activeTab && activeTab === '7') {
    return dispatch =>
      axios
        .get(`${CREDIT_NOTE_BASE}?${qs.stringify(qsObj)}`, cancelToken ? { cancelToken: cancelToken.token } : {})
        .then(res => thunkHandler(dispatch, get(res, 'data.data.data', []), NEW_INVOICES, 'ERROR', res))
        .then(res => thunkHandler(dispatch, get(res, 'data.filters_stats', []), NEW_STATS, 'ERROR', res))
        .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
  }

  return dispatch =>
    axios
      .get(`${INVOICE_BASE}?${qs.stringify(qsObj)}`, cancelToken ? { cancelToken: cancelToken.token } : {})
      .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_INVOICES, 'ERROR', res))
      .then(res => thunkHandler(dispatch, get(res, 'data.filters_stats', []), NEW_STATS, 'ERROR', res))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getInvoices

export function getReminders(params, productTour = 'inactive', options = {}) {
  const productTourInvoice = invoiceExample[0];

  if (typeof params !== 'object' && !Array.isArray(params)) params = {};
  const qsObj = {};
  const { activeTab, page, code, customer, startDate, endDate, cancelToken, type, direction, filters } = params;
  if (!filters) return;
  const { Estado, Origen, Tipo } = filters;

  if (activeTab) qsObj.filter = typeof activeTab == 'string' ? activeTab : filterCatalog(activeTab);
  if (page) qsObj.page = page;
  if (code) qsObj.code = code;
  if (customer) qsObj.customer = customer;
  if (startDate) {
    qsObj.start = startDate;
    if (endDate) qsObj.end = endDate;
    else qsObj.end = moment().format('YYYY-MM-DD');
  }
  if (type && direction) qsObj.sort = `${type}-${direction}`;
  const filtersStatus = getTrueProperties(Estado);
  const filtersOrigin = getTrueProperties(Origen);
  const filtersType = getTrueProperties(Tipo);
  if (filtersStatus !== '') qsObj.status = `${filtersStatus}`;
  if (filtersType !== '') qsObj.type = `${filtersType}`;
  if (filtersOrigin !== '') qsObj.origin = `${filtersOrigin}`;
  // END if
  if (typeof params.dueDate === 'number') qsObj.due = params.dueDate;

  function parseDemoInvoice(invoice, options) {
    invoice.due_date = moment().unix();
    invoice.customer.name = 'Factura de prueba';
    invoice.customer.email = get(options, 'email');
    return invoice;
  } // END parseDemoInvoice

  if (productTour === 's1') {
    const objectResponse = {};
    objectResponse.data = {};
    objectResponse.data.data = [parseDemoInvoice(productTourInvoice, options)];
    objectResponse.data.message = 'Successfull';
    objectResponse.data.code = 101;
    objectResponse.data.count = 1;
    objectResponse.data.pages = 1;
    return dispatch =>
      Promise.resolve(objectResponse)
        .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_INVOICES, 'ERROR', res))
        .then(res => thunkHandler(dispatch, get(res, 'data.filters_stats', []), NEW_STATS, 'ERROR', res))
        .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
  }

  return dispatch =>
    axios
      .get(`${INVOICE_BASE}?${qs.stringify(qsObj)}`, cancelToken ? { cancelToken: cancelToken.token } : {})
      .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_INVOICES, 'ERROR', res))
      .then(res => thunkHandler(dispatch, get(res, 'data.filters_stats', []), NEW_STATS, 'ERROR', res))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getReminders

function filterCatalog(n) {
  switch (parseInt(n)) {
    case 1:
      return;

    case 2:
      return 'paid';

    case 3:
      return 'late_payment';

    case 4:
      return 'current';

    case 6:
      return 'cancel';

    default:
      return 'uncollectable';
  } // END switch
}

function newfilterCatalog(n) {
  switch (parseInt(n)) {
    case 1:
      return;

    case 2:
      return 'cfdi';

    case 3:
      return 'invoice';

    case 4:
      return 'recurrent';

    case 6:
      return 'cancel';
  } // END switch

  return null;
} // END filterCatalog

export function exportInvoices(params = {}, source) {
  if (typeof params !== 'object') params = {};
  const qsObj = {};
  const { activeTab, page, code, customer, startDate, endDate } = params;

  // if (activeTab) qsObj.filter = filterCatalog(params.activeTab);
  if (activeTab && source) qsObj.filter = filterCatalog(activeTab);
  if (activeTab && !source && activeTab !== '6') qsObj.type = newfilterCatalog(activeTab);
  if (activeTab && activeTab === '6') qsObj.filter = filterCatalog(activeTab);
  if (page) qsObj.page = page;
  if (code) qsObj.code = code;
  if (customer) qsObj.customer = customer;
  if (startDate) {
    qsObj.start = startDate;
    if (endDate) qsObj.end = endDate;
    else qsObj.end = moment().format('YYYY-MM-DD');
  } // END if
  if (typeof params.dueDate === 'number') qsObj.due = params.dueDate;

  return dispatch =>
    axios
      .get(`${INVOICE_EXPORT}?${qs.stringify(qsObj)}`, { responseType: 'arraybuffer' })
      .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_EXPORT_INVOICES, 'ERROR', res))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END exportInvoices

export function getSingleInvoice(uuid) {
  return dispatch =>
    axios
      .get(parseUrl(INVOICE_SINGLE, { uuid }))
      .then(res => thunkHandler(dispatch, get(res, 'data.data', {}), NEW_SINGLE_INVOICE, 'ERROR'));
  // .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getSingleInvoice

export function updateSingleInvoice(uuid, body) {
  return dispatch =>
    axios.patch(parseUrl(INVOICE_SINGLE, { uuid }), body).then(async () => {
      try {
        const response = await axios.get(parseUrl(INVOICE_SINGLE, { uuid }));
        await thunkHandler(dispatch, get(response, 'data.data', {}), NEW_SINGLE_INVOICE, 'ERROR');
      } catch (error) {
        thunkErrorHanlder(error, dispatch, 'ERROR');
      }
    });
} // END updateSingleInvoice

export function updateInvoiceNotesLocal(uuid, body) {
  return dispatch =>
    axios
      .patch(parseUrl(INVOICE_SINGLE, { uuid }), body)
      .then(() => axios.get(parseUrl(INVOICE_SINGLE, { uuid })))
      .then(res => {
        const payloadNotes = get(body, 'notes');
        const invoice = get(res, 'data.data', {});
        const invoiceNotes = get(invoice, 'notes');

        if (payloadNotes !== invoiceNotes) {
          invoice.notes = payloadNotes;
        }

        return thunkHandler(dispatch, invoice, NEW_SINGLE_INVOICE, 'ERROR');
      });
} // END updateNotesLocal

export function updateInvoiceCollectionLocal(uuid, body) {
  return dispatch =>
    axios
      .patch(parseUrl(INVOICE_SINGLE, { uuid }), body)
      .then(() => axios.get(parseUrl(INVOICE_SINGLE, { uuid })))
      .then(res => {
        const collectiblePayload = get(body, 'collectible');
        const invoice = get(res, 'data.data', {});
        const collectibleInvoice = get(invoice, 'collectible');

        if (collectiblePayload !== collectibleInvoice) {
          invoice.collectible = collectiblePayload;
        }

        return thunkHandler(dispatch, invoice, NEW_SINGLE_INVOICE, 'ERROR');
      });
} // END updateInvoiceCollectionLocal

export function addFilesToInvoice(uuid, body) {
  const options = { headers: { 'content-type': 'multipart/form-data' } };
  return dispatch =>
    axios
      .post(parseUrl(INVOICE_FILES, { uuid }), body, options)
      .then(() => axios.get(parseUrl(INVOICE_SINGLE, { uuid })))
      .then(
        res =>
          new Consequence({
            dispatch,
            payload: { data: get(res, 'data.data', {}) },
            eventTypes: { success: NEW_SINGLE_INVOICE, error: 'ERROR' }
          })
      );
} // END addFilesToInvoice

export function getSingleInvoiceCollection(uuid, axiosConfiguration = {}, productTour = 'inactive') {
  const productTourReminder = reminderExample[0];

  function parseDemoReminder(reminder) {
    reminder.date = moment().unix();
    return reminder;
  }

  if (productTour === 's2') {
    const objectResponse = {};
    objectResponse.data = {};
    objectResponse.data.data = [parseDemoReminder(productTourReminder)];
    return dispatch =>
      Promise.resolve(objectResponse)
        .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_INVOICE_COLLECTION, 'ERROR'))
        .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
  }

  return dispatch =>
    axios
      .get(parseUrl(INVOICE_SINGLE_COLLECTION, { uuid }), axiosConfiguration)
      .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_INVOICE_COLLECTION, 'ERROR'))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getSingleInvoiceCollection

export function getSingleInvoiceItems(uuid) {
  return dispatch =>
    axios.get(parseUrl(INVOICE_ITEMS, { uuid })).then(
      res =>
        new Consequence({
          dispatch,
          payload: { data: get(res, 'data.data', {}) },
          eventTypes: { success: NEW_INVOICE_ITEMS, error: 'ERROR' }
        })
    );
} //END getSingleInvoiceItems

export function getClientInvoices(uuid, invoices) {
  return dispatch =>
    axios.get(`${parseUrl(CLIENT_INVOICES_FROM_UUID, { uuid })}?q=${invoices}`).then(
      res =>
        new Consequence({
          dispatch,
          payload: { data: get(res, 'data.data', {}) },
          eventTypes: { success: INVOICES_TO_PAY, error: 'ERROR' }
        })
    );
} // END clientInvoices

export function getClientUnpaidInvoices(uuid) {
  return dispatch =>
    axios.get(`${parseUrl(CLIENT_INVOICES, { uuid })}?filter=to_pay`).then(
      res =>
        new Consequence({
          dispatch,
          payload: { data: get(res, 'data.data', {}) },
          eventTypes: { success: NEW_INVOICES, error: 'ERROR' }
        })
    );
} // END getClientUnpaidInvoices

export function getInvoicesToPay(payload) {
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: INVOICES_TO_PAY,
        payload: payload
      })
    );
} // END saveCompanySegmentation

export function createInvoice(payload) {
  return dispatch =>
    axios.post(INVOICE_CFDI, payload).then(
      res =>
        new Consequence({
          dispatch,
          payload: { data: get(res, 'data.data', {}) },
          eventTypes: { success: NEW_SINGLE_INVOICE, error: 'ERROR' }
        })
    );
} // END createInvoice

export function createNoteInvoice(payload) {
  return dispatch =>
    axios.post(INVOICE_INVOICE, payload).then(
      res =>
        new Consequence({
          dispatch,
          payload: { data: get(res, 'data.data', {}) },
          eventTypes: { success: NEW_SINGLE_INVOICE, error: 'ERROR' }
        })
    );
} // END createInvoice

export function emitInvoiceCfdi(uuid, payload) {
  return dispatch =>
    axios.post(parseUrl(INVOICE_EMIT_CFDI, { uuid }), payload).then(
      res =>
        new Consequence({
          dispatch,
          payload: { data: get(res, 'data.data', {}) },
          eventTypes: { success: NEW_SINGLE_INVOICE, error: 'ERROR' }
        })
    );
} // END emitInvoiceCfdi

export function importXlm(formData) {
  return dispatch =>
    axios.post(INVOICE_IMPORT_XML, formData, { headers: { 'content-type': 'multipart/form-data' } }).then(
      res =>
        new Consequence({
          dispatch,
          payload: { data: res },
          eventTypes: { success: NEW_IMPORT_INVOICES, error: 'ERROR' }
        })
    );
} // END importXlm

export function importSaleNotes(payload) {
  return dispatch =>
    axios.post(INVOICE_NOTE_IMPORT, payload, { headers: { 'content-type': 'multipart/form-data' } }).then(
      res =>
        new Consequence({
          dispatch,
          payload: { data: res },
          eventTypes: { success: NEW_IMPORT_NOTES, error: 'ERROR' }
        })
    );
} // END importSaleNotes

export function cancelInvoice(uuid, cfdi_seal_version, motive_id, uuid_replacement) {
  const data = {
    motive_id,
    cfdi_seal_version
  };

  if (uuid_replacement) {
    data.uuid_replacement = uuid_replacement;
  }

  return dispatch =>
    axios
      .delete(parseUrl(INVOICE_CANCEL_CFDI, { uuid }), { data })
      .then(() => axios.get(parseUrl(INVOICE_SINGLE, { uuid, cfdi_seal_version })))
      .then(
        res =>
          new Consequence({
            dispatch,
            payload: { data: get(res, 'data.data', {}) },
            eventTypes: { success: NEW_SINGLE_INVOICE, error: 'ERROR' }
          })
      );
} // END

export function notifyCancelInvoice(uuid, body) {
  return dispatch =>
    axios
      .post(parseUrl(INVOICE_CANCEL_NOTIFY, { uuid }), body)
      .then(() => axios.get(parseUrl(INVOICE_SINGLE, { uuid })))
      .then(
        res =>
          new Consequence({
            dispatch,
            payload: { data: get(res, 'data.data', {}) },
            eventTypes: { success: NEW_SINGLE_INVOICE, error: 'ERROR' }
          })
      );
} // END

export function createCreditNote(payload) {
  return dispatch =>
    axios.post(CREDIT_NOTE_BASE, payload).then(
      res =>
        new Consequence({
          dispatch,
          payload: { data: get(res, 'data.data', {}) },
          eventTypes: { success: NEW_SINGLE_CREDIT_NOTE, error: 'ERROR' }
        })
    );
} // END createContract

export function getSingleCreditNote(uuid) {
  return dispatch =>
    axios
      .get(parseUrl(CREDIT_NOTE_SINGLE, { uuid }))
      .then(res => thunkHandler(dispatch, get(res, 'data.data', {}), NEW_SINGLE_CREDIT_NOTE, 'ERROR'));
  // .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getSingleInvoice

export function cancelCreditNote(uuid) {
  return dispatch =>
    axios
      .delete(parseUrl(CREDIT_NOTE_CANCEL_CFDI, { uuid }))
      .then(() => axios.get(parseUrl(CREDIT_NOTE_SINGLE, { uuid })))
      .then(
        res =>
          new Consequence({
            dispatch,
            payload: { data: get(res, 'data.data', {}) },
            eventTypes: { success: NEW_SINGLE_CREDIT_NOTE, error: 'ERROR' }
          })
      );
} // END cancelCreditNote

export function notifyCancelCreditNote(uuid, body) {
  return dispatch =>
    axios
      .post(parseUrl(CREDIT_NOTE_CANCE_NOTIFY, { uuid }), body)
      .then(() => axios.get(parseUrl(CREDIT_NOTE_SINGLE, { uuid })))
      .then(
        res =>
          new Consequence({
            dispatch,
            payload: { data: get(res, 'data.data', {}) },
            eventTypes: { success: CREDIT_NOTE_SINGLE, error: 'ERROR' }
          })
      );
} // END

export function getInvoiceCreditNotes(uuid) {
  return dispatch =>
    axios
      .get(parseUrl(INVOICE_CREDIT_NOTE, { uuid }))
      .then(res => thunkHandler(dispatch, get(res, 'data.data', {}), NEW_SINGLE_CREDIT_NOTE, 'ERROR'));
  // .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getSingleInvoice

export function getVisibilityFilters(filters, updateTable = true, searching = true) {
  let initialValuesTags = {
    Tipo: {
      cfdi: false,
      invoice: false
    },
    Estado: {
      late_payment: false,
      current: false,
      paid: false,
      cancel: false
    },
    Origen: {
      ar: false,
      bar: false,
      xml: false,
      sat: false
    }
  };
  filters.map(item => {
    if (item.label in initialValuesTags) {
      if (item.value) {
        item.value.split(',').map(value => {
          initialValuesTags[item.label][value] = true;
        });
      }
    }
  });
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: NEW_FILTERS,
        payload: { filters, updateTable, searching }
      }),
      dispatch({
        type: NEW_VALUES,
        payload: initialValuesTags
      })
    );
} // END getVisibilityFilters

export function updateLoadingTable(loadingTable) {
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: NEW_LOADING_TABLE,
        payload: loadingTable
      })
    );
} // END updateLoadingTable

export function getInvoicesXCV2(allFilters, cancelToken, module = 'PorCobrar') {
  if (typeof allFilters !== 'object' && !Array.isArray(allFilters)) allFilters = {};
  const { personalized = {}, filters = {} } = allFilters;
  const emptyAllFilters = isEmpty(allFilters);
  const emptyPersonalized = isEmpty(personalized);
  const emptyFilters = isEmpty(filters);
  const qsPersonalizedConfig = { encode: false };
  let url = `${INVOICE_BASE}`;

  if (has(personalized, 'credit_note')) {
    url = `${CREDIT_NOTE_BASE}`;
    delete personalized.credit_note;
  }

  if (!emptyAllFilters) {
    if (!emptyPersonalized) url = url.concat(`?${qsFilters.stringify(personalized, qsPersonalizedConfig)}`);
    if (!emptyFilters) {
      let strFilters = String(encodeURIComponent(qsFilters.stringify(filters))).replace(/&/gi, '%26'); // Library issue
      url = url.concat(`${emptyPersonalized ? '?filters=' : '&filters='}${strFilters}`);
    }
  }
  if (module === 'PorCobrar') {
    url = url + '&reminder=1';
  }
  return dispatch =>
    axios
      .get(url, cancelToken ? { cancelToken: cancelToken.token } : {})
      .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_INVOICES, 'ERROR', res))
      .then(res => thunkHandler(dispatch, get(res, 'data.filters_stats', []), NEW_STATS, 'ERROR', res))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getInvoicesV2

export function getInvoicesV2(allFilters, cancelToken, module = '') {
  if (typeof allFilters !== 'object' && !Array.isArray(allFilters)) allFilters = {};
  const { personalized = {}, filters = {} } = allFilters;
  const emptyAllFilters = isEmpty(allFilters);
  const emptyPersonalized = isEmpty(personalized);
  const emptyFilters = isEmpty(filters);
  const qsPersonalizedConfig = { encode: false };
  let url = `${INVOICE_BASE}`;

  if (has(personalized, 'credit_note')) {
    url = `${CREDIT_NOTE_BASE}`;
    delete personalized.credit_note;
  }

  if (!emptyAllFilters) {
    if (!emptyPersonalized) url = url.concat(`?${qsFilters.stringify(personalized, qsPersonalizedConfig)}`);
    if (!emptyFilters) {
      let strFilters = String(encodeURIComponent(qsFilters.stringify(filters))).replace(/&/gi, '%26'); // Library issue
      url = url.concat(`${emptyPersonalized ? '?filters=' : '&filters='}${strFilters}`);
    }
  }
  if (module === 'PorCobrar') {
    url = url + '&reminder=1';
  }
  return dispatch =>
    axios
      .get(url, cancelToken ? { cancelToken: cancelToken.token } : {})
      .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_INVOICES, 'ERROR', res))
      .then(res => thunkHandler(dispatch, get(res, 'data.filters_stats', []), NEW_STATS, 'ERROR', res))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END getInvoicesV2

export function exportInvoicesV2(allFilters, activeTab) {
  if (typeof allFilters !== 'object' && !Array.isArray(allFilters)) allFilters = {};

  const { personalized = {}, filters = {} } = allFilters;
  const emptyAllFilters = isEmpty(allFilters);
  const emptyPersonalized = isEmpty(personalized);
  const emptyFilters = isEmpty(filters);
  const qsPersonalizedConfig = { encode: false };
  let url = `${INVOICE_EXPORT}`;

  if(activeTab === "1"){
    url = `${INVOICE_EXPORT}`;
  }

  if(activeTab === "7"){
    url = `${CREDIT_NOTE_EXPORT}`;
  }

  if (!emptyAllFilters) {
    if (!emptyPersonalized) url = url.concat(`?${qsFilters.stringify(personalized, qsPersonalizedConfig)}`);
    if (!emptyFilters) {
      let strFilters = String(encodeURIComponent(qsFilters.stringify(filters))).replace(/&/gi, '%26'); // Library issue
      url = url.concat(`${emptyPersonalized ? '?filters=' : '&filters='}${strFilters}`);
    }
  }
  return dispatch =>
    axios
      .get(url, { responseType: 'arraybuffer' })
      .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_EXPORT_INVOICES, 'ERROR', res))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
} // END exportInvoicesV2

export function resetSearching() {
  return dispatch =>
    Promise.resolve(
      dispatch({
        type: NEW_SEARCHING,
        payload: false
      })
    );
} // END updateLoadingTable

export const setReloadInvoiceTable = (isReload = false) => {
  return dispatch => Promise.resolve(dispatch({ type: RELOAD_INVOIDE_TABLE, payload: isReload }));
};

export function createInvoiceFromPortal(uuid_client, uuid_note, body) {
  return dispatch =>
    axios.post(parseUrl(CLIENT_GENERATE_CFDI, { uuid: uuid_client, id: uuid_note }), body).then(res => {
      const customer = get(res, 'data.data');
      return thunkHandler(dispatch, customer, NEW_SINGLE_INVOICE, 'ERROR');
    });
} // END createInvoiceFromPortal

export const changeInvoiceSelect = (data, checked) => {
  return (dispatch, getState) => {
    const selected = getState().invoices.selected;
    if (Array.isArray(data)) {
      let newDataArr = [...selected];
      data.forEach(el => {
        const exist = selected.find(item => item.uuid === el.uuid);
        if (!exist && checked) newDataArr.push(el);
        if (exist && !checked) newDataArr = newDataArr.filter(item => item.uuid !== el.uuid);
      });
      dispatch({
        type: CHANGE_INVOICE_SELECT,
        payload: { data: newDataArr }
      });
    } else {
      let newData = [];
      const exist = selected.find(item => item.uuid === data.uuid);
      if (exist) newData = selected.filter(item => item.uuid !== data.uuid);
      else newData = [...selected, data];
      dispatch({
        type: CHANGE_INVOICE_SELECT,
        payload: { data: newData }
      });
    }
  };
};

export const clearInvoiceSelect = () => ({
  type: CHANGE_INVOICE_SELECT,
  payload: { data: [] }
});


// WEBPACK FOOTER //
// ./src/redux/actions/invoiceActions.js